import {
  createContext,
  Dispatch,
  FC,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState
} from 'react';
import { InformationDialog } from '../lib/components';

type GlobalInformationDialogProps = {
  setOpenInformationDialog: Dispatch<SetStateAction<boolean>>;
  setContentInformationDialog: Dispatch<SetStateAction<string>>;
  setTitleInformationDialog: Dispatch<SetStateAction<string | undefined>>;
  setIconInformationDialog: Dispatch<SetStateAction<JSX.Element | undefined>>;
  setConfirmButtonTextInformationDialog: Dispatch<SetStateAction<string | undefined>>;
  setCancelButtonTextInformationDialog: Dispatch<SetStateAction<string | undefined>>;
};

const informationDialogContext = createContext<GlobalInformationDialogProps | null>(null);

export const InformationDialogProvider: FC<PropsWithChildren> = ({ children }) => {
  const [openInformationDialog, setOpenInformationDialog] = useState<boolean>(false);
  const [contentInformationDialog, setContentInformationDialog] = useState<string>(
    'YOU NEED TO PROVIDE A CUSTOM MESSAGE'
  );
  const [titleInformationDialog, setTitleInformationDialog] = useState<string>();
  const [iconInformationDialog, setIconInformationDialog] = useState<JSX.Element>();
  const [confirmButtonTextInformationDialog, setConfirmButtonTextInformationDialog] =
    useState<string>();
  const [cancelButtonTextInformationDialog, setCancelButtonTextInformationDialog] =
    useState<string>();

  const closeDialog = () => setOpenInformationDialog(false);
  const onCancel = cancelButtonTextInformationDialog ? closeDialog : undefined;
  return (
    <informationDialogContext.Provider
      value={{
        setOpenInformationDialog,
        setContentInformationDialog,
        setTitleInformationDialog,
        setIconInformationDialog,
        setConfirmButtonTextInformationDialog,
        setCancelButtonTextInformationDialog
      }}
    >
      {children}
      <InformationDialog
        icon={iconInformationDialog}
        title={titleInformationDialog}
        open={openInformationDialog}
        content={contentInformationDialog}
        confirmButtonText={confirmButtonTextInformationDialog}
        cancelButtonText={cancelButtonTextInformationDialog}
        onClose={closeDialog}
        onCancel={onCancel}
      />
    </informationDialogContext.Provider>
  );
};

export const useInformationDialog = () => {
  const informationDialogStore = useContext(informationDialogContext);

  if (!informationDialogStore) {
    throw new Error('no information dialog store');
  }

  return informationDialogStore;
};
